import React, { useEffect, useState } from 'react';
import { axiosGetCall, axiosPostCall } from '../../../services/apisCall';
import Logger from '../../../lib/Logger';
const logger = new Logger("kycListTable");
import { renderErrorMessage, renderSuccessMessage } from '../../../lib/toastMessage';
import { CustomMenu } from '../../../components/menu/customMenu';

import TableFilters from './tableFilter';

//mui 
import { TableCell, Box, List, ListItem, MenuItem, Menu, styled, Select, Button, useTheme } from '@mui/material';

//mui icons
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { configFile } from '../../../config';
import { PaginationTable } from 'src/components/tables/paginationTable';
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';
import { ConfirmDialog } from 'src/components/custom-dialog';
import Iconify from 'src/components/iconify';

const columns = [

    { id: 'server_id', label: 'Server ID', minWidth: 110, align: 'center' },
    { id: 'es_protocol', label: 'Protocol', minWidth: 110, align: 'center' },
    { id: 'es_host', label: 'Host', minWidth: 110, align: 'center' },
    { id: 'es_port', label: 'Port', minWidth: 110, align: 'center' },
    { id: 'es_user_name', label: 'User Name', minWidth: 20, align: 'center' },
    { id: 'es_password', label: 'Password', minWidth: 20, align: 'center' },
    { id: 'create_by', label: 'Created By', minWidth: 110, align: 'center' },
    { id: 'create_date', label: 'Created Date', minWidth: 20, align: 'center' },
    { id: 'status', label: 'Status', minWidth: 110, align: 'center' },
    { id: 'actions', label: 'Action', minWidth: 20, align: 'center' },

];

const menuItems = [
    { value: 0, label: 'Inactive', id: '101' },
    { value: 1, label: 'Active', id: '102' },
];

export const VoiceElasticServerList = ({ loadit }) => {
      const theme = useTheme();
    const [page, setPage] = useState(0)
    const [rowsPerPage, setRowsPerPage] = useState(10)
    const [rows, setRows] = useState([])
    const [count, setCount] = useState(0)

    const [search, setSearch] = useState("")
    const [load, setLoad] = useState(true)
    const [networkError, setNetworkError] = useState(false)
    const [loading, setLoading] = useState(true);
    const [selectedUser, setSelectedUser] = useState("")
    const [openStatus, setOpenStatus] = useState(false);
    const [status, setStatus] = useState('');

    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);




    const handleChange = (value) => setSearch(value)

    const GetlistEsBackServer = async () => {
        const skip = rowsPerPage * page;
        try {
            const params = { skip, limit: rowsPerPage }
            if (search) params.serverId = search
            setNetworkError(false)
            const { esServerList, totalDocuments } = await axiosGetCall("getlistEsBackupServer", params)
            setRows(esServerList)
            setCount(totalDocuments)
        } catch (error) {
            logger.error("plan", error);
            setNetworkError(true)
            setRows([])
            setCount(0)
            renderErrorMessage(error?.message)
        }
        setLoading(false)
    }

    useEffect(() => {
        // if (load) {
        setLoading(true)
        GetlistEsBackServer()
        setLoad(false)
        // }
    }, [load, loadit])

    const handleClick = (event, user) => {
        setAnchorEl(event.currentTarget);
        setSelectedUser(user);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleStatusClick = () => {
        setOpenStatus(true);
        setAnchorEl(null);
    };

    const handleCloseStatus = () => {
        setAnchorEl(null);
        setOpenStatus(false);
        setStatus();
    };

    const handleConfirmStatus = async (serverId, status) => {
        try {
            const params = {
                serverId,
                newStatus: status,
            };
            const data = await axiosGetCall('changeEsBackupServerStatus', params);
            renderSuccessMessage(data?.message);
            GetlistEsBackServer();
            setOpenStatus(false);
            setAnchorEl(null);
            setStatus();
        } catch (error) {
            logger.error('Gateway List change status', error);
            renderErrorMessage(error?.message);
        }
    };
    const tableFilter = <TableFilters search={search} handleChange={handleChange} setLoad={setLoad} count={count} setPage={setPage} />

    const ActionJsx = (id, align, value, ...other) => {
        const user = other[3];

        return (
            <TableCell
                key={id}
                align={align}
                sx={{
                    color: 'grey.400',
                    borderBottom: '0.5px dashed',
                    borderColor: 'grey.300',
                    size: 'small',
                }}
            >
                <MoreVertIcon
                    sx={{ color: 'grey.700', cursor: 'pointer', height: '18px', width: '18px' }}
                    aria-controls={open ? 'filters-menu' : undefined}
                    aria-haspopup="true"
                    aria-expanded={open ? 'true' : undefined}
                    onClick={(e) => handleClick(e, user)}
                />
            </TableCell>
        );
    };


    const Content = () => (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: '16px',
            }}
        >
            <List>
                <ListItem
                    sx={{
                        display: 'flex',
                        gap: '7px',
                        fontWeight: 400,
                        color: 'grey.700',
                        '&:hover': {
                            color: 'grey.800',
                            backgroundColor: 'grey.300',
                            cursor: 'pointer',
                        },
                    }}
                    onClick={handleStatusClick}
                >
                    <SwapHorizIcon sx={{ color: '#1976d2', height: '17px', margin: '5px' }} />
                    Change Status
                </ListItem>
            </List>
        </Box>
    );

    const ActionModals = () => {
        return (
            <CustomMenu
                anchorEl={anchorEl}
                handleClose={handleClose}
                Content={Content} />
        )
    }
    const statusjsx = (id, align, value, ...other) => {
        let label = '';
        let boxStyles = {};

        if (value === 1) {
            label = 'Active';
            boxStyles = {
                color: '#50AB64',
                backgroundColor: 'rgba(40, 167, 69, 0.20)',
            };
        } else if (value === 0) {
            label = 'Inactive';
            boxStyles = {
                color: '#D19244',
                backgroundColor: 'rgba(209, 146, 68, 0.20)',
            };
        }

        return (
            <TableCell
                key={id}
                align={align}
                sx={{
                    borderBottom: '0.5px dashed',
                    borderColor: 'grey.300',
                    background: 'transparent',
                }}
            >
                <Box
                    sx={{
                        borderRadius: '6px',
                        fontWeight: 600,
                        fontSize: '14px',
                        display: 'inline-block',
                        ...boxStyles,
                        px: '12px',
                        py: '2px',
                    }}
                >
                    {label}
                </Box>
            </TableCell>
        );
    };
      const passwordjsx = (id, align, value) => {
        const handleClick = () => {
          navigator.clipboard.writeText(value);
          renderSuccessMessage('Password copied to clipboard!');
        };
    
        return (
          <TableCell
            key={id}
            align={align}
            sx={{
              color: 'grey.700',
              borderBottom: '0.5px dashed',
              borderColor: 'grey.300',
              cursor: 'pointer',
            }}
            onClick={handleClick}
          >
            <Iconify icon="prime:copy" width="20px" color={theme.palette.primary.main} />
          </TableCell>
        );
      };

    return (
        <>
            {/* <ToastContainer /> */}
            <PaginationTable
                page={page}
                tableFilter={tableFilter}
                ActionJsx={ActionJsx}
                ActionModals={ActionModals}
                setLoad={setLoad}
                setPage={setPage}
                rowsPerPage={rowsPerPage}
                setRowsPerPage={setRowsPerPage}
                count={count}
                error={networkError}
                loading={loading}
                setLoading={setLoading}
                rows={rows}
                columns={columns}
                handleChange={handleChange}
                search={search}
                calculatedHeight={288}
                status={statusjsx}
                passwordjsx={passwordjsx}
            />
            <ConfirmDialog
                open={openStatus}
                onClose={handleCloseStatus}
                title="Change Status"
                content={
                    <span>
                        Are you sure you want to change status.
                        <Select
                            id="change-status"
                            defaultValue={selectedUser.status}
                            value={status}
                            onChange={(e) => setStatus(e.target.value)}
                            fullWidth
                            sx={{
                                marginTop: '10px',
                                '& .MuiSelect-select': {
                                    paddingTop: '10px',
                                    paddingBottom: '10px',
                                    display: 'flex',
                                    alignItems: 'center',
                                },
                                '& .MuiOutlinedInput-notchedOutline': {
                                    padding: 0,
                                },
                            }}
                        >
                            {menuItems.map((item) => {
                                return (
                                    <MenuItem
                                        key={item.value}
                                        value={item.value}
                                        sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}
                                    >
                                        <span>{item.label}</span>
                                    </MenuItem>
                                );
                            })}
                        </Select>
                    </span>
                }
                action={
                    <Button
                        color="secondary"
                        variant="contained"
                        sx={{
                            color: '#fff',
                            height: '30px',
                            backgroundColor: 'primary.main',
                            '&:hover': {
                                backgroundColor: 'primary.main',
                            },
                            boxShadow: 'none',
                            marginRight: '10px',
                        }}
                        onClick={() => handleConfirmStatus(selectedUser.server_id, status)}
                    >
                        Confirm
                    </Button>
                    
                }
            />
        </>
    )
}
